import { Trainer } from '../../redux/features/OnDemand/onDemandWorkouts'

export const trainerFullName = (trainer: Trainer): string | undefined =>
  trainer.firstName && trainer.lastName
    ? `${trainer.firstName} ${trainer.lastName}`
    : trainer.firstName || trainer.lastName
